import { earningsFilterStores } from "./earningsStoreNames";
import { mockSubUsersData } from "./wlDemoData";

const mockEarningsFilterOptionsData = {
    "stores": earningsFilterStores,
    "labels": [
        {
            "id": 1,
            "name": "Midnight Melodies Co."
        },
        {
            "id": 2,
            "name": "Harmonic Fusion Records"
        },
        {
            "id": 3,
            "name": "Retro Rhythms Music"
        },
        {
            "id": 4,
            "name": "Bassline Bridge Studios"
        },
        {
            "id": 5,
            "name": "Orbitwave Audio"
        },
        {
            "id": 6,
            "name": "Lyrical Landslide Records"
        },
        {
            "id": 7,
            "name": "Pulsepoint Productions"
        },
        {
            "id": 8,
            "name": "Riff Radiance Music"
        },
        {
            "id": 9,
            "name": "Symphony Spectrum Studios"
        },
        {
            "id": 10,
            "name": "Vivid Vibes Entertainment"
        }
    ],
    "releases": [
        {
          "id": 1,
          "label": 1,
          "name": "Rising Silhouette"
        },
        {
          "id": 2,
          "label": 1,
          "name": "Melodic Harmony"
        },
        {
          "id": 3,
          "label": 1,
          "name": "Echoing Harmony"
        },
        {
          "id": 4,
          "label": 1,
          "name": "Whispering Rhapsody"
        },
        {
          "id": 5,
          "label": 2,
          "name": "Rising Rhapsody"
        },
        {
          "id": 6,
          "label": 2,
          "name": "Mystic Voyage"
        },
        {
          "id": 7,
          "label": 3,
          "name": "Echoing Rhapsody"
        },
        {
          "id": 8,
          "label": 3,
          "name": "Echoing Echo"
        },
        {
          "id": 9,
          "label": 3,
          "name": "Echoing Symphony"
        },
        {
          "id": 10,
          "label": 3,
          "name": "Echoing Voyage"
        },
        {
          "id": 11,
          "label": 4,
          "name": "Echoing Silhouette"
        },
        {
          "id": 12,
          "label": 4,
          "name": "Serene Legacy"
        },
        {
          "id": 13,
          "label": 5,
          "name": "Serene Odyssey"
        },
        {
          "id": 14,
          "label": 5,
          "name": "Eternal Echo"
        },
        {
          "id": 15,
          "label": 5,
          "name": "Radiant Silhouette"
        },
        {
          "id": 16,
          "label": 5,
          "name": "Radiant Symphony"
        },
        {
          "id": 17,
          "label": 6,
          "name": "Harmonic Rhapsody"
        },
        {
          "id": 18,
          "label": 6,
          "name": "Harmonic Odyssey"
        },
        {
          "id": 19,
          "label": 6,
          "name": "Rising Harmony"
        },
        {
          "id": 20,
          "label": 6,
          "name": "Echoing Paradise"
        },
        {
          "id": 21,
          "label": 7,
          "name": "Radiant Silhouette"
        },
        {
          "id": 22,
          "label": 7,
          "name": "Eternal Rhapsody"
        },
        {
          "id": 23,
          "label": 8,
          "name": "Serene Symphony"
        },
        {
          "id": 24,
          "label": 8,
          "name": "Harmonic Phenomenon"
        },
        {
          "id": 25,
          "label": 9,
          "name": "Radiant Paradise"
        },
        {
          "id": 26,
          "label": 9,
          "name": "Serene Harmony"
        },
        {
          "id": 27,
          "label": 10,
          "name": "Whispering Paradise"
        },
        {
          "id": 28,
          "label": 10,
          "name": "Vivid Legacy"
        },
        {
          "id": 29,
          "label": 10,
          "name": "Echoing Legacy"
        }
    ],
    "tracks": [
        {
           "id":1,
           "name":"Celestial Voyage Mix",
           "release":19
        },
        {
           "id":2,
           "name":"Veil of the Vortex Mix",
           "release":2
        },
        {
           "id":3,
           "name":"Celestial Voyage Mix",
           "release":2
        },
        {
           "id":4,
           "name":"Dusk Horizon",
           "release":2
        },
        {
           "id":5,
           "name":"Echoes of Eternity Remix",
           "release":3
        },
        {
           "id":6,
           "name":"Whispering Willows Mix",
           "release":3
        },
        {
           "id":7,
           "name":"Ocean's Embrace Remix",
           "release":4
        },
        {
           "id":8,
           "name":"Symphony of the Sirens Remix",
           "release":4
        },
        {
           "id":9,
           "name":"Twilight Echo",
           "release":4
        },
        {
           "id":10,
           "name":"Whisper in the Wind Mix",
           "release":5
        },
        {
           "id":11,
           "name":"Midnight Mirage",
           "release":5
        },
        {
           "id":12,
           "name":"Galactic Rhapsody",
           "release":5
        },
        {
           "id":13,
           "name":"Shadow's Serenity Remix",
           "release":6
        },
        {
           "id":14,
           "name":"Stellar Drift Mix",
           "release":6
        },
        {
           "id":15,
           "name":"Phoenix Rebirth",
           "release":7
        },
        {
           "id":16,
           "name":"Wandering Spirit's Tune",
           "release":7
        },
        {
           "id":17,
           "name":"Cosmic Dreams",
           "release":7
        },
        {
           "id":18,
           "name":"Whispering Sands",
           "release":8
        },
        {
           "id":19,
           "name":"Dusk Horizon",
           "release":9
        },
        {
           "id":20,
           "name":"Tempest's Lament",
           "release":9
        },
        {
           "id":21,
           "name":"Galactic Rhapsody",
           "release":9
        },
        {
           "id":22,
           "name":"Aurora's Awakening Mix",
           "release":9
        },
        {
           "id":23,
           "name":"Enchanted Forest Lullaby Remix",
           "release":10
        },
        {
           "id":24,
           "name":"Celestial Voyage Mix",
           "release":11
        },
        {
           "id":25,
           "name":"Echo of the Ancients Mix",
           "release":12
        },
        {
           "id":26,
           "name":"Whispering Sands",
           "release":12
        },
        {
           "id":27,
           "name":"Whispering Willows Mix",
           "release":13
        },
        {
           "id":28,
           "name":"Melancholy of the Moon Mix",
           "release":14
        },
        {
           "id":29,
           "name":"Rhythm of the Rain",
           "release":21
        },
        {
           "id":30,
           "name":"Northern Lights Nocturne Mix",
           "release":21
        },
        {
           "id":31,
           "name":"Ode to the Horizon Remix",
           "release":16
        },
        {
           "id":32,
           "name":"Dancing in the Stardust",
           "release":16
        },
        {
           "id":33,
           "name":"Solar Flare Symphony Mix",
           "release":16
        },
        {
           "id":34,
           "name":"Dancing in the Stardust",
           "release":17
        },
        {
           "id":35,
           "name":"Lunar Whispers",
           "release":17
        },
        {
           "id":36,
           "name":"Sapphire Skies Remix",
           "release":17
        },
        {
           "id":37,
           "name":"Lunar Whispers",
           "release":18
        },
        {
           "id":38,
           "name":"Echo of the Ancients Mix",
           "release":19
        },
        {
           "id":39,
           "name":"Ethereal Journey Remix",
           "release":19
        },
        {
           "id":40,
           "name":"Cosmic Dreams",
           "release":19
        },
        {
           "id":41,
           "name":"Dancing in the Stardust",
           "release":19
        },
        {
           "id":42,
           "name":"Twilight Echo",
           "release":20
        },
        {
           "id":43,
           "name":"Mystic River Flow Mix",
           "release":21
        },
        {
           "id":44,
           "name":"Whispering Sands",
           "release":21
        },
        {
           "id":45,
           "name":"Ethereal Journey Remix",
           "release":21
        },
        {
           "id":46,
           "name":"Solar Symphony",
           "release":22
        },
        {
           "id":47,
           "name":"Twilight Echo",
           "release":23
        },
        {
           "id":48,
           "name":"Quantum Heartbeat Remix",
           "release":23
        },
        {
           "id":49,
           "name":"Starlight Serenade",
           "release":23
        },
        {
           "id":50,
           "name":"Ethereal Journey Remix",
           "release":23
        },
        {
           "id":51,
           "name":"Sapphire Skies Remix",
           "release":24
        },
        {
           "id":52,
           "name":"Midnight in Neon",
           "release":24
        },
        {
           "id":53,
           "name":"Dusk Horizon",
           "release":24
        },
        {
           "id":54,
           "name":"Ethereal Journey Remix",
           "release":24
        },
        {
           "id":55,
           "name":"Ode to the Horizon Remix",
           "release":25
        },
        {
           "id":56,
           "name":"Shadow's Serenity Remix",
           "release":26
        },
        {
           "id":57,
           "name":"Velvet Dreamscape Remix",
           "release":27
        },
        {
           "id":58,
           "name":"Dusk Horizon",
           "release":27
        },
        {
           "id":59,
           "name":"Celestial Tides Mix",
           "release":27
        },
        {
           "id":60,
           "name":"Midnight Mirage",
           "release":28
        },
        {
           "id":61,
           "name":"Midnight in Neon",
           "release":28
        },
        {
           "id":62,
           "name":"Lunar Whispers",
           "release":28
        },
        {
           "id":63,
           "name":"Whispering Sands",
           "release":29
        },
        {
           "id":64,
           "name":"Whispering Willows Mix",
           "release":29
        },
        {
           "id":65,
           "name":"Quantum Heartbeat Remix",
           "release":29
        }
    ],
    "sub_users": mockSubUsersData
        .filter(subUser => subUser.is_active)
        .map(subUser => ({
            id: subUser.id,
            name: subUser.friendly_name || subUser.username,
        })),
}
export default mockEarningsFilterOptionsData;